'use client'

import { useCart, useSearchParams } from '@/lib/hooks'
import React, { use } from 'react'

import { RefContext, type Refs } from '@/components/providers/ref-provider'

export const useBarcode = () => {
  const [isListening, setIsListening] = React.useState(false)
  const { addToCartByBarcode } = useCart()
  const { barcodeInputRef } = use(RefContext) as Refs
  const { cartId } = useSearchParams()

  // If the barcode input is focused, set the listening state to true
  React.useEffect(() => {
    const onFocus = () => setIsListening(true)
    const onBlur = () => setIsListening(false)

    const inputElement = barcodeInputRef.current

    if (inputElement) {
      inputElement.addEventListener('focus', onFocus)
      inputElement.addEventListener('blur', onBlur)
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('focus', onFocus)
        inputElement.removeEventListener('blur', onBlur)
      }
    }
  }, [])

  const focusBarcodeInput = () => barcodeInputRef?.current?.focus()

  const clearBarcodeInput = () => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.value = ''
    }
  }

  const submitBarcodeProduct = (data: FormData) => {
    const barcode = data?.get('barcode-value')
    if (barcode) {
      addToCartByBarcode({ barcode, cartId })
    }
    clearBarcodeInput()
  }

  return {
    focusBarcodeInput,
    clearBarcodeInput,
    submitBarcodeProduct,
    isListening,
  }
}
